import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import Layout from "../components/Layout";

const ResultPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const results = location.state || [];
  const normalizedResults = results.map(r => r?.data?.data || r?.data || r);

  /*useEffect(() => {
    const isLoggedIn = localStorage.getItem("isLoggedIn");
    if (isLoggedIn !== "true") navigate("/");
  }, [navigate]);*/

  const isCsvFormat = normalizedResults.length > 1;

  const columns = [
    { name: "Mobile No",  selector: row => row.mobileNo || "N/A",  sortable: true },
    { name: "SIM No",     selector: row => row.simNo || "N/A",      sortable: true },
    { name: "Used",       selector: row => row.usedDataUsage ? `${row.usedDataUsage} ${row.dataUsageUnits || ""}` : "N/A" },
    { name: "Available",  selector: row => row.remainingDataUsage ? `${row.remainingDataUsage} ${row.dataUsageUnits || ""}` : "N/A" },
    { name: "Allocated",  selector: row => row.totalDataUsage ? `${row.totalDataUsage} ${row.dataUsageUnits || ""}` : "N/A" },
    { name: "Plan Name",  selector: row => row.planName || "N/A", wrap: true },
  ];

  const downloadCSV = () => {
    if (!normalizedResults.length) return;
    const headers = ["Mobile No", "SIM No", "Used", "Available", "Allocated", "Plan Name"];
    const csvRows = [headers.join(",")];
    normalizedResults.forEach(row => {
      csvRows.push([
        row.mobileNo || "N/A",
        row.simNo || "N/A",
        row.usedDataUsage ? `${row.usedDataUsage} ${row.dataUsageUnits || ""}` : "N/A",
        row.remainingDataUsage ? `${row.remainingDataUsage} ${row.dataUsageUnits || ""}` : "N/A",
        row.totalDataUsage ? `${row.totalDataUsage} ${row.dataUsageUnits || ""}` : "N/A",
        `"${row.planName || "N/A"}"`,
      ].join(","));
    });
    const blob = new Blob([csvRows.join("\n")], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `data-usage-results-${new Date().toISOString().split("T")[0]}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  };

  const tableStyles = {
    table:   { style: { backgroundColor: "#1c1c1c" } },
    headRow: { style: { backgroundColor: "#2a2a2a", color: "#ffffff", fontSize: "13px", fontWeight: "600", borderBottom: "1px solid #333333" } },
    rows:    { style: { backgroundColor: "#1c1c1c", color: "#dddddd", borderBottom: "1px solid #222222", "&:hover": { backgroundColor: "#252525" } } },
    pagination: { style: { backgroundColor: "#1c1c1c", color: "#aaaaaa", borderTop: "1px solid #2a2a2a" } },
  };

  return (
    <Layout title="Data Usage Results">
      {isCsvFormat ? (
        <>
          <div className="flex justify-between items-center mb-4">
            <p className="text-sm" style={{ color: "#888888" }}>{normalizedResults.length} records</p>
            <button
              onClick={downloadCSV}
              className="px-4 py-2 text-sm font-semibold rounded-xl transition-colors"
              style={{ backgroundColor: "#ffc20e", color: "#000000" }}
              onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "#e6ae00"; }}
              onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "#ffc20e"; }}
            >
              Download CSV
            </button>
          </div>
          <div className="rounded-2xl overflow-hidden" style={{ border: "1px solid #2a2a2a" }}>
            <DataTable
              columns={columns}
              data={normalizedResults}
              pagination
              paginationPerPage={10}
              customStyles={tableStyles}
              highlightOnHover
              responsive
              dense
            />
          </div>
        </>
      ) : normalizedResults.length === 1 ? (
        (() => {
          const row = normalizedResults[0];
          return (
            <div className="max-w-lg">
              {/* Plan name badge */}
              <div
                className="rounded-xl px-5 py-3 mb-6 text-center"
                style={{ backgroundColor: "#ffc20e22", border: "1px solid #ffc20e55" }}
              >
                <p className="text-xs font-semibold uppercase tracking-wide mb-0.5" style={{ color: "#ffc20e" }}>Plan</p>
                <p className="text-lg font-bold" style={{ color: "#ffc20e" }}>{row.planName || "N/A"}</p>
              </div>

              {/* Stat cards */}
              <div className="grid grid-cols-3 gap-4">
                {[
                  { label: "Used",      value: row.used      },
                  { label: "Available", value: row.available },
                  { label: "Allocated", value: row.allocated },
                ].map(({ label, value }) => (
                  <div
                    key={label}
                    className="rounded-2xl p-5 text-center"
                    style={{ backgroundColor: "#1c1c1c", border: "1px solid #2a2a2a" }}
                  >
                    <p className="text-xs font-semibold uppercase tracking-wider mb-2" style={{ color: "#888888" }}>{label}</p>
                    <p className="text-xl font-bold" style={{ color: "#ffffff" }}>{value || "N/A"}</p>
                  </div>
                ))}
              </div>

              {/* Meta */}
              <div className="mt-5 rounded-2xl p-5 space-y-3" style={{ backgroundColor: "#1c1c1c", border: "1px solid #2a2a2a" }}>
                {[
                  { label: "Mobile No", value: row.mobileNo },
                  { label: "SIM No",    value: row.simNo    },
                ].map(({ label, value }) => (
                  <div key={label} className="flex justify-between text-sm">
                    <span style={{ color: "#888888" }}>{label}</span>
                    <span className="font-medium" style={{ color: "#ffffff" }}>{value || "N/A"}</span>
                  </div>
                ))}
              </div>

              <button
                onClick={() => navigate(-1)}
                className="mt-6 px-6 py-2.5 rounded-xl text-sm font-medium transition-colors"
                style={{ border: "1px solid #2a2a2a", color: "#aaaaaa" }}
                onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "#2a2a2a"; }}
                onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "transparent"; }}
              >
                ← Back
              </button>
            </div>
          );
        })()
      ) : (
        <p style={{ color: "#888888" }}>No data available</p>
      )}
    </Layout>
  );
};

export default ResultPage;
